import ContextOnboarding, {
  onboardingCounterKey,
} from './contextual-onboarding';
import useSuppressFlagStorage from './useSuppressFlagStorage';

export { useSuppressFlagStorage, onboardingCounterKey };
export default ContextOnboarding;
